import { render } from "./Upload.vue?vue&type=template&id=2633f851"
const script = {}
script.render = render

export default script